var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AfterViewInit, ElementRef, OnChanges, OnInit, QueryList, SimpleChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HasSubscriptions } from '../../has-subscriptions';
import { CommunicationService } from '../../../services/communication.service';
import { Listing } from '../../../classes/listing';
import { PreferencesService } from '../../../services/preferences.service';
import { ListingsService } from '../../../services/listings.service';
import { SortBy, ViewModes } from '../../../classes/enums';
import { ListingCardComponent } from '../../../shared/components/listing-card/listing-card.component';
import { CacheService } from '../../../services/cache.service';
import { Pagination } from '../../../classes/pagination';
import { Helper } from '../../../classes/helper';
import { DomManipulationService } from '../../../services/dom-manipulation/dom-manipulation.service';
import { OfficeService } from '../../../services/office.service';
import { debounceTime } from 'rxjs/operators';
import { Filters } from '../../../classes/user-preferences';
var GalleryViewDesktopComponent = /** @class */ (function (_super) {
    __extends(GalleryViewDesktopComponent, _super);
    function GalleryViewDesktopComponent(fb, communicationService, preferencesService, listingsService, cache, domManipulationService, officeService) {
        var _this = _super.call(this) || this;
        _this.fb = fb;
        _this.communicationService = communicationService;
        _this.preferencesService = preferencesService;
        _this.listingsService = listingsService;
        _this.cache = cache;
        _this.domManipulationService = domManipulationService;
        _this.officeService = officeService;
        _this.showSpecificListings = [];
        _this.showSearchBar = true;
        _this.showRelatedOffice = false;
        _this.startingPageNumber = 0;
        _this.isDoneFetchingListings = false;
        _this.pagination = new Pagination(0, 20);
        _this.filters = new Filters();
        _this.ViewModes = ViewModes;
        _this.showOnlySelectedCluster = false;
        _this.pins = [];
        // Sample set of listings generated from pin information before we've retrieved the full listing information from the server
        _this.listOfSortedFakeListings = [];
        _this.showingListings = [];
        _this.isPaginated = false;
        _this.pages = [];
        _this.sortOptions = [
            {
                key: 'gallery.sortby.newest',
                value: SortBy.NEWEST
            },
            {
                key: 'gallery.sortby.oldest',
                value: SortBy.OLDEST
            },
            {
                key: 'gallery.sortby.priceLowToHigh',
                value: SortBy.PRICE_LOW_TO_HIGH
            },
            {
                key: 'gallery.sortby.priceHighToLow',
                value: SortBy.PRICE_HIGH_TO_LOW
            }
        ];
        _this.Listing = Listing;
        _this.sortForm = _this.fb.group({
            sort: SortBy.NEWEST
        });
        return _this;
    }
    GalleryViewDesktopComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.addSub(this.communicationService.listings.listingsClicked.subscribe(function (listings) {
            _this.showSpecificListings = listings;
            _this.sortAndPaginate();
        }));
        this.addSub(this.preferencesService.filtersChanged.subscribe(function (filters) {
            _this.filters = filters;
        }));
        this.sortForm.controls['sort'].setValue(this.preferencesService.getGallerySorting());
        this.addSub(this.preferencesService.viewModesChanged.subscribe(function (mode) {
            _this.activeViewMode = mode;
            if (_this.activeViewMode === ViewModes.GALLERY) {
                // fetch the related office
                var pagination = new Pagination(0, 1);
                if (_this.showingListings.length > 0) {
                    _this.officeService.getRelatedOffice(_this.showingListings[0].lat, _this.showingListings[0].lng, pagination).then(function (offices) {
                        if (offices.results.length > 0) {
                            _this.relatedOffice = offices.results[0];
                        }
                    });
                }
            }
        }));
    };
    GalleryViewDesktopComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        // Any time the sort changes, sort the listings. Skip the first one when the component is initialized.
        this.addSub(this.sortForm.valueChanges.pipe(debounceTime(200)).subscribe(function (value) {
            _this.preferencesService.setGallerySorting(value.sort);
            _this.sortAndPaginate(true);
        }));
    };
    GalleryViewDesktopComponent.prototype.ngOnChanges = function (changes) {
        if (changes.showSpecificListings)
            this.sortAndPaginate();
        if (changes.startingPageNumber)
            this.pagination.pageNumber = changes.startingPageNumber.currentValue;
    };
    GalleryViewDesktopComponent.prototype.onHoverListingCard = function (event) {
        this.communicationService.map.highlightMarker.next(event);
    };
    GalleryViewDesktopComponent.prototype.onGalleryCardClicked = function (listing) {
        this.communicationService.map.highlightMarker.next({ action: 'leave', listingId: listing.listingId });
        this.preferencesService.addNextListings(this.showingListings.map(function (l) { return ({ listingId: l.listingId, detailUrl: l.detailUrl }); }));
    };
    GalleryViewDesktopComponent.prototype.sortAndPaginate = function (isSort) {
        if (isSort === void 0) { isSort = false; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.showOnlySelectedCluster = this.showSpecificListings.length > 1;
                        this.showSpecificListings = this.sortListings(this.showSpecificListings);
                        this.listOfSortedFakeListings = this.sortListings(this.listOfSortedFakeListings);
                        this.buildPagination();
                        if (!(isSort || this.showOnlySelectedCluster)) return [3 /*break*/, 2];
                        // if a cluster is clicked, we always show the first page
                        return [4 /*yield*/, this.changePage(0)];
                    case 1:
                        // if a cluster is clicked, we always show the first page
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    GalleryViewDesktopComponent.prototype.highlightCard = function (listingId) {
        var _this = this;
        // give angular some time to render the new cards
        setTimeout(function () {
            _this.listingCards.forEach(function (card) {
                card.setHighlight(listingId);
            });
        }, 100);
    };
    /**
     * Resets the pagination and moves the page into view of the container for the pagination
     */
    GalleryViewDesktopComponent.prototype.reset = function () {
        this.pages = [];
        this.pagination.pageNumber = this.startingPageNumber;
    };
    /**
     *
     * @param pageNumber
     */
    GalleryViewDesktopComponent.prototype.changePage = function (pageNumber) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.pagination.pageNumber = pageNumber;
                        // this.pagination.pageNumber = 0;
                        if (this.activeViewMode !== ViewModes.GALLERY) {
                            this.domManipulationService.scrollIntoView(this.container, true);
                        }
                        if (!this.showOnlySelectedCluster) return [3 /*break*/, 1];
                        // TODO: why cant we use pagination.offset here
                        this.showingListings = this.showSpecificListings.slice(this.pagination.offset, Math.min(this.showSpecificListings.length, this.pagination.offset + this.pagination.limit));
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.fetchAndDisplayPage()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GalleryViewDesktopComponent.prototype.sortListings = function (listings) {
        var _this = this;
        var sortBy = this.sortForm.get('sort').value;
        return listings.sort(function (o1, o2) { return Listing.sortBy(o1, o2, sortBy, _this.filters.priceType === 1); });
    };
    // TODO: maybe cache what was fetched
    GalleryViewDesktopComponent.prototype.fetchAndDisplayPage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var listingIds, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        listingIds = this.listOfSortedFakeListings.slice(this.pagination.offset, Math.min(this.listOfSortedFakeListings.length, this.pagination.offset + this.pagination.limit)).map(function (it) { return it.listingId; }).join(',');
                        if (!(listingIds && listingIds.length)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.listingsService.getListingsPreview(listingIds, this.activeViewMode === ViewModes.GALLERY)];
                    case 1:
                        response = _a.sent();
                        this.showingListings = this.sortListings(response.results);
                        if (response.office) {
                            this.relatedOffice = response.office;
                            this.relatedOffice.telephone = Helper.formatPhoneNumber(this.relatedOffice.telephone);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        this.showingListings = [];
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GalleryViewDesktopComponent.prototype.buildPagination = function () {
        this.reset();
        this.isPaginated = this.showOnlySelectedCluster ? this.showSpecificListings.length > this.pagination.limit : this.listOfSortedFakeListings.length > this.pagination.limit;
        // this.pagination.totalPages = Math.ceil((this.showOnlySelectedCluster ? this.showSpecificListings.length : this.listOfSortedFakeListings.length) / this.pagination.limit);
        this.pagination.setTotalResults(this.showOnlySelectedCluster ? this.showSpecificListings.length : this.listOfSortedFakeListings.length);
        var itemsToShow = this.showOnlySelectedCluster ? this.showSpecificListings.slice(0, this.pagination.limit) : this.listOfSortedFakeListings.slice(0, this.pagination.limit);
        this.pages.push({ pageNumber: 0, listingIds: itemsToShow.map(function (it) { return it.listingId; }) });
        for (var i = 1; i < this.pagination.totalPages; i++) {
            if (this.showOnlySelectedCluster) {
                this.pages.push({ pageNumber: i, listingIds: this.showSpecificListings.slice(this.pagination.limit * i, this.pagination.limit * (i + 1)).map(function (it) { return it.listingId; }) });
            }
            else {
                this.pages.push({ pageNumber: i, listingIds: this.listOfSortedFakeListings.slice(this.pagination.limit * i, this.pagination.limit * (i + 1)).map(function (it) { return it.listingId; }) });
            }
        }
    };
    Object.defineProperty(GalleryViewDesktopComponent.prototype, "listingData", {
        set: function (pins) {
            if (!pins)
                return;
            this.pins = pins;
            this.showOnlySelectedCluster = false;
            this.showSpecificListings = [];
            this.listOfSortedFakeListings = this.sortListings(this.getListingsFromPins());
            this.buildPagination();
            // Make sure we scroll to the top anytime we get new listings
            this.domManipulationService.scrollToTop(this.galleryContainerRef);
            // Check if we're coming back to the map from a listing detail and need to highlight that listing.
            var selectedListingId = this.cache.get(this.cache.KeySelectedListingId, true);
            if (selectedListingId) {
                var showListing = new Listing();
                showListing.listingId = selectedListingId;
                this.showSpecificListings = [showListing];
                this.highlightListing = selectedListingId;
            }
            else {
                this.pagination.pageNumber = this.startingPageNumber;
                this.fetchAndDisplayPage();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GalleryViewDesktopComponent.prototype, "highlightListing", {
        set: function (listingId) {
            var _this = this;
            // if a single item is clicked, we need to navigate to the page where that item is
            // and highlight it
            if (!listingId)
                return;
            var isItemInGallery = false;
            for (var _i = 0, _a = this.showingListings; _i < _a.length; _i++) {
                var item = _a[_i];
                if (listingId === item.listingId) {
                    isItemInGallery = true;
                    break;
                }
            }
            if (isItemInGallery) {
                this.highlightCard(listingId);
            }
            else {
                var pageNumber = 1;
                for (var _b = 0, _c = this.pages; _b < _c.length; _b++) {
                    var page = _c[_b];
                    if (page.listingIds.indexOf(listingId) >= 0) {
                        pageNumber = page.pageNumber;
                        break;
                    }
                }
                this.changePage(pageNumber).then(function () {
                    _this.highlightCard(listingId);
                });
            }
            this.communicationService.map.highlightMarker.next({ action: 'enter', listingId: listingId });
        },
        enumerable: true,
        configurable: true
    });
    GalleryViewDesktopComponent.prototype.getListingsFromPins = function () {
        if (!this.pins)
            return;
        return this.pins.map(function (p) { return new Listing({ listingId: p.listingId, listPrice: p.listPrice, listingDate: p.listingDate, pricePerSqFt: p.pricePerSqft }); });
    };
    return GalleryViewDesktopComponent;
}(HasSubscriptions));
export { GalleryViewDesktopComponent };
